/* eslint-disable */
import ctype from 'component-type';
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the type of a given `handler` is invalid
 * @export
 * @class AuthInvalidHandlerTypeError
 * @extends {Error}
 */
export class AuthInvalidHandlerTypeError extends Error {
  /**
   * Creates an instance of AuthInvalidHandlerTypeError
   * @param {string} message The Error `message`
   * @memberof AuthInvalidHandlerTypeError
   */
  constructor(message) {
    super(message);
    this.name = `AuthInvalidHandlerTypeError`;
  }
}

/**
 * Called when the type of a given `handler` is invalid
 * @param {any} handler The invalid `handler`
 * @returns {never} never
 */
const throwAuthInvalidHandlerTypeError = (handler) => {
  throw new AuthInvalidHandlerTypeError(
    stripIndent(`
    Expected "handler" to be of type Function.
    Got: "${ctype(handler)}".
    `),
  );
};

export default throwAuthInvalidHandlerTypeError;
